import { DetailedKeyword, ProjectKeywordsResponse } from "../models/ProjectKeywordsResponse";
import { Contract, ContractsResponse } from "../models/projects/ContractsResponse";
import { ProjectFileItem } from "../models/projects/ProjectFilesResponse";
import { NewformaFolderTreeNode } from "../components/_base/NewformaFolderTree";

export class ProjectHelper {
    static sortKeywords(keywordsResponse: ProjectKeywordsResponse): DetailedKeyword[] {
        return keywordsResponse.items.sort((a, b) => a.displayOrder - b.displayOrder);
    }

    static sortContracts(contractsResponse: ContractsResponse): Contract[] {
        return contractsResponse.items.sort((a, b) => a.subject.localeCompare(b.subject));
    }

    /** Maps the folder-shaped items returned by GET /v1/files into the tree shape used by SubfolderPickerFluent9. */
    static mapProjectFolders(items: ProjectFileItem[] = []): NewformaFolderTreeNode[] {
        return items
            .filter((item) => item.type === "folder")
            .map((item) => {
                const children = ProjectHelper.mapProjectFolders(item.items ?? item.children ?? []);
                return {
                    id: item.nrn,
                    name: item.name,
                    children: children.length ? children : undefined,
                };
            });
    }

    /**
     * Returns the folder names from the root of `folders` down to (and including) the folder
     * with `targetId`, e.g. ["Subfolder1", "Subfolder2"]. Returns undefined if not found.
     */
    static getFolderNamePath(folders: NewformaFolderTreeNode[], targetId: string): string[] | undefined {
        for (const folder of folders) {
            if (folder.id === targetId) {
                return [folder.name];
            }
            if (folder.children?.length) {
                const childPath = ProjectHelper.getFolderNamePath(folder.children, targetId);
                if (childPath) {
                    return [folder.name, ...childPath];
                }
            }
        }
        return undefined;
    }
}
